import { useState } from "react";

// hook for text input in forms
const useInput = (validateValue) => {
  const [enteredValue, setEnteredValue] = useState("");
  const [isTouched, setIsTouched] = useState(false);

  // colour border of text input depending on whether the input is valid
  const valueIsValid = validateValue(enteredValue); 
  const hasError = !valueIsValid && isTouched;
  const borderColor = !valueIsValid ? "red" : "green"

  const valueChangeHandler = (event) => {
    setEnteredValue(event.target.value);
  };

  const inputBlurHandler = (event) => {
    setIsTouched(true);
  };

  const reset = () => {
    setEnteredValue("");
    setIsTouched(false);
  };


  return {
    value: enteredValue,
    isValid: valueIsValid,
    hasError,
    borderColor, 
    valueChangeHandler,
    inputBlurHandler,
    reset,
  };
};

export default useInput;
